import { z } from "zod/v4";

export const PaymentEnvObject = {
    stripePublishableKey: process.env.VITE_STRIPE_PUBLISHABLE_KEY,
    pciBookingBrand: process.env.VITE_PCI_BOOKING_BRAND,
    pciBookingCss: process.env.VITE_PCI_BOOKING_CSS,
    pciBookingSquaredCss: process.env.VITE_PCI_BOOKING_SQUARED_CSS,
} as const;

// in the future we can make config non optional when we know what providers are used
export const PaymentConfigSchema = z
    .object({
        stripePublishableKey: z.string().default(""),
        pciBookingBrand: z.string().optional(),
        pciBookingCss: z.string().optional(),
        pciBookingSquaredCss: z.string().optional(),
    })
    .transform((data) => ({
        ...data,
        pciBookingSquaredCss: data.pciBookingSquaredCss || PaymentEnvObject.pciBookingCss,
    }));

export type TPaymentConfig = z.infer<typeof PaymentConfigSchema>;
